import controller from './mobile-connect-callback.controller';

export default {
  controller,
  template: require('./mobile-connect-callback.html')
};



// WEBPACK FOOTER //
// src/app/components/mobile-connect-callback/mobile-connect-callback.component.ts